import React, { Component } from "react"
import { List } from "semantic-ui-react"

//material ui
import Menu from "@material-ui/core/Menu"
import Notification from "../Notification"
export default class MenuNavbarMobile extends Component {
	render() {
		const {
			classes,
			handlegetnotidefault,
			notification,
			NotificationMenu,
			isNotificationMenuOpen,
			handleNotificationMenuClose
		} = this.props
		return (
			<Menu
				anchorEl={NotificationMenu}
				anchorOrigin={{ vertical: "top", horizontal: "right" }}
				transformOrigin={{ vertical: "top", horizontal: "right" }}
				open={isNotificationMenuOpen}
				onClose={handleNotificationMenuClose}
			>
				<List className={classes.root1} selection>
					{notification.map((option, i) => (
						<Notification
							key={i}
							i={i}
							classes={classes}
							option={option}
							handlegetnotidefault={handlegetnotidefault}
							handleopen={this.handleopen}
							{...this.props}
						/>
					))}
				</List>
			</Menu>
		)
	}
}
